/* Inline Lucide-style stroke icons (ported from the Claude design). */

interface IconProps {
  size?: number;
}

export function IcoInstagram({ size = 17 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function IcoCaret({ size = 9 }: IconProps) {
  return (
    <svg className="caret" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 9l6 6 6-6" />
    </svg>
  );
}

export function IcoChevronDown({ size = 30 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 9l6 6 6-6" />
    </svg>
  );
}

export function IcoPhone({ size = 18 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.69 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.33 1.85.56 2.81.69A2 2 0 0 1 22 16.92z" />
    </svg>
  );
}

export function IcoMail({ size = 18 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="m22 7-10 6L2 7" />
    </svg>
  );
}

/* Product-detail spec icons — exact paths from the live didiers.co.uk site */
export function IcoDefrost({ size = 34 }: IconProps) {
  return (
    <svg viewBox="0 0 86 81" width={size} height={size} aria-hidden="true">
      <path
        fill="currentColor"
        d="M44.8 38.5 56 49.8l.2 11.5a1.9 1.9 0 1 0 3.8 0v-.1l-.1-7.6 4.3 4.4c.7.7 1.9.8 2.6.1.7-.7.8-1.9.1-2.6L62.4 51l7.6.2c1 0 1.9-.8 1.9-1.8 0-.5-.2-1-.6-1.4-.3-.3-.8-.5-1.3-.5l-11.4-.3-11.1-11.3 15.9.1 8.2 8c.7.7 1.9.7 2.6 0 .7-.7.7-1.9 0-2.6L68.7 36h6.2c1 0 1.9-.8 1.9-1.8 0-.5-.2-1-.6-1.4-.4-.3-.8-.5-1.3-.5h-6.2l5.5-5.2c.8-.7.8-1.9.1-2.6-.7-.7-1.9-.7-2.6 0l-8.3 7.9-15.9-.1L58.8 21l11.5-.2a1.9 1.9 0 1 0 0-3.8h-.1l-7.6.1 4.4-4.3c.7-.7.8-1.9.1-2.6-.7-.7-1.9-.7-2.6 0L60 14.6l.2-7.6c0-.5-.2-1-.5-1.4-.7-.7-1.9-.8-2.7 0-.4.3-.6.8-.6 1.3l-.3 11.4-11.2 11.2.1-15.9 8-8.2c.7-.7.7-1.9 0-2.6-.8-.8-2-.7-2.7 0L45 8.2V2c0-.5-.2-1-.5-1.3-.7-.7-1.9-.7-2.6 0-.4.4-.6.8-.6 1.3v6.2l-5.2-5.5c-.7-.8-1.9-.8-2.6-.1-.8.7-.8 1.9-.1 2.6l7.9 8.3-.1 15.9L30 18.2l-.2-11.5c0-.5-.2-1-.6-1.3-.7-.7-1.9-.7-2.6 0-.4.4-.5.8-.5 1.4l.1 7.6-4.3-4.4c-.7-.7-1.9-.8-2.6-.1-.7.7-.8 1.9-.1 2.6l4.3 4.4-7.5-.1c-1 0-1.9.8-1.9 1.8s.8 1.9 1.8 1.9l11.4.3 11.2 11.3-15.9-.1-8.2-8c-.7-.7-1.9-.7-2.6 0-.7.7-.7 1.9 0 2.6l5.4 5.3H11c-1 0-1.9.8-1.9 1.8s.8 1.9 1.8 1.9h6.3l-5.5 5.2c-.8.7-.8 1.9-.1 2.6.7.8 1.9.8 2.6.1l8.3-7.9 15.9.1L27.2 47l-11.5.2a1.9 1.9 0 1 0 0 3.8l7.6-.1-4.3 4.2c-.7.7-.8 1.9-.1 2.6.7.7 1.9.8 2.6.1l4.4-4.3-.1 7.5c0 1 .8 1.9 1.8 1.9s1.9-.8 1.9-1.8l.3-11.4 11.3-11.2"
      />
      <path
        fill="currentColor"
        d="M42.8 55.7c-2 8.4-7.8 10.6-7.9 16.7 0 4.2 2.7 8.4 7.9 8.4 4.8 0 7.9-4.2 7.9-8.4 0-5.9-5.9-8.3-7.9-16.7zm-4.5 13.8c-.5 4.7 1.5 6.8 3.5 8.3-3.4-.6-5.2-3.7-3.5-8.3z"
      />
    </svg>
  );
}

export function IcoShelfLife({ size = 34 }: IconProps) {
  return (
    <svg viewBox="0 0 86 81" width={size} height={size} aria-hidden="true">
      <path
        fill="currentColor"
        d="M24.6 1.04c-1 0-1.8.8-1.8 1.8v10.8c-3 .8-5.3 3.5-5.3 6.8 0 3.9 3.2 7 7 7s7-3.2 7-7c0-3.2-2.3-6-5.3-6.8V2.84c.2-1-.6-1.8-1.6-1.8zm36.8 0c-1 0-1.8.8-1.8 1.8v10.8c-3 .8-5.3 3.5-5.3 6.8 0 3.9 3.2 7 7 7s7-3.2 7-7c0-3.2-2.3-6-5.3-6.8V2.84c.2-1-.6-1.8-1.6-1.8zm-49.1 5.3c-4.8 0-8.8 4-8.8 8.8v56.1c0 4.8 4 8.8 8.8 8.8h61.3c4.8 0 8.8-4 8.8-8.8v-56.1c0-4.8-4-8.8-8.8-8.8h-5.2c-.9 0-1.8.8-1.8 1.8 0 .9.9 1.8 1.8 1.8h5.2c3 0 5.3 2.3 5.3 5.3v15.8H7v-15.8c0-3 2.3-5.3 5.3-5.3h5.2c.9 0 1.8-.8 1.8-1.8 0-.9-.9-1.8-1.8-1.8h-5.2zm19.3 0c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8h22.8c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8H31.6zm-7 10.5c2 0 3.5 1.6 3.5 3.5 0 2-1.6 3.5-3.5 3.5s-3.5-1.6-3.5-3.5c0-2 1.5-3.5 3.5-3.5zm36.8 0c2 0 3.5 1.6 3.5 3.5 0 2-1.6 3.5-3.5 3.5s-3.5-1.6-3.5-3.5c0-2 1.6-3.5 3.5-3.5zM7 34.34h72v36.8c0 3-2.3 5.3-5.3 5.3H12.3c-3 0-5.3-2.3-5.3-5.3v-36.8z"
      />
    </svg>
  );
}

export function IcoReheat({ size = 34 }: IconProps) {
  return (
    <svg viewBox="0 0 86 81" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M30 64c-7-6-7-15 0-21 5-4 6-9 3-15M43 64c-7-6-7-15 0-21 5-4 6-9 3-15M56 64c-7-6-7-15 0-21 5-4 6-9 3-15" />
    </svg>
  );
}
